import { render, staticRenderFns } from "./GeneratedReports.vue?vue&type=template&id=0305ca48&scoped=true&"
import script from "./GeneratedReports.vue?vue&type=script&lang=js&"
export * from "./GeneratedReports.vue?vue&type=script&lang=js&"
import style0 from "./GeneratedReports.vue?vue&type=style&index=0&id=0305ca48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0305ca48",
  null
  
)

export default component.exports